export type HttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

function getCookie(name: string): string | null {
  const cookies = document.cookie ? document.cookie.split(";") : [];
  for (const raw of cookies) {
    const cookie = raw.trim();
    if (cookie.startsWith(`${name}=`)) {
      return decodeURIComponent(cookie.substring(name.length + 1));
    }
  }
  return null;
}

let csrfTokenMemory: string | null = null;

async function ensureCsrfToken() {
  // This app sets CSRF_COOKIE_HTTPONLY=True, so JS cannot read csrftoken cookie.
  // Instead we fetch a token from /api/csrf/ and keep it in memory for X-CSRFToken.
  if (csrfTokenMemory) return;

  const resp = await fetch("/api/csrf/", { method: "GET", credentials: "include" });
  if (!resp.ok) return;
  const data = (await resp.json().catch(() => null)) as null | { csrfToken?: string };
  if (data?.csrfToken) csrfTokenMemory = data.csrfToken;
}

export async function apiFetch(input: string, init: RequestInit = {}) {
  const method = (init.method?.toUpperCase() ?? "GET") as HttpMethod;
  const headers = new Headers(init.headers ?? {});

  if (!["GET", "HEAD", "OPTIONS", "TRACE"].includes(method)) {
    await ensureCsrfToken();
    // Prefer in-memory token (works with HttpOnly cookie). Fall back to cookie if readable.
    const csrf = csrfTokenMemory || getCookie("csrftoken");
    if (csrf) headers.set("X-CSRFToken", csrf);
  }

  // Django session auth requires cookies.
  const resp = await fetch(input, {
    ...init,
    method,
    headers,
    credentials: "include"
  });

  return resp;
}

